module.exports = __webpack_public_path__ + "592afe48aa7e894c872a2a46d69bd0a0.svg";